import { render, staticRenderFns } from "./ThreadDiscussion.vue?vue&type=template&id=39a3756a&scoped=true&"
import script from "./ThreadDiscussion.vue?vue&type=script&lang=js&"
export * from "./ThreadDiscussion.vue?vue&type=script&lang=js&"
import style0 from "./ThreadDiscussion.vue?vue&type=style&index=0&id=39a3756a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a3756a",
  null
  
)

/* custom blocks */
import block0 from "./ThreadDiscussion.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports